import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { CurrencyPairCalendarImpl } from "../model/impl/CurrencyPairCalendarImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class CurrencyPairCalendarImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: CurrencyPairCalendarImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.baseCcy != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairCalendarImplEncoder.fidTypeMap.get(1),
        false,
        encodable.baseCcy,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.holidays != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        true,
        CurrencyPairCalendarImplEncoder.fidTypeMap.get(2),
        false,
        encodable.holidays,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBaseccy != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairCalendarImplEncoder.fidTypeMap.get(3),
        false,
        encodable.nonBaseccy,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.tenorToValueAndFixingDateSet != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        true,
        CurrencyPairCalendarImplEncoder.fidTypeMap.get(4),
        false,
        encodable.tenorToValueAndFixingDateSet,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.tenorToValueDateSet != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        true,
        CurrencyPairCalendarImplEncoder.fidTypeMap.get(5),
        false,
        encodable.tenorToValueDateSet,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.isNdfEnabled != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairCalendarImplEncoder.fidTypeMap.get(6),
        false,
        encodable.isNdfEnabled,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.maxValueDate != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairCalendarImplEncoder.fidTypeMap.get(7),
        true,
        encodable.maxValueDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.tradeDateRollDate != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairCalendarImplEncoder.fidTypeMap.get(8),
        true,
        encodable.tradeDateRollDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.tradeDateRollTime != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairCalendarImplEncoder.fidTypeMap.get(9),
        true,
        encodable.tradeDateRollTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairCalendarImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,CurrencyPairCalendarImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "com.bcdfx.model.calendar.Holiday"],
    [3, "java.lang.String"],
    [4, "com.bcdfx.model.calendar.TenorToValueAndFixingDate"],
    [5, "com.bcdfx.model.calendar.TenorToValueDate"],
    [6, "java.lang.Boolean"],
    [7, "com.bcdfx.model.StandardDate"],
    [8, "com.bcdfx.model.StandardDate"],
    [9, "com.bcdfx.model.StandardTime"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: CurrencyPairCalendarImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairCalendarImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.baseCcy = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: Array<CubiqTS.Holiday> = this.baseEncoder.readObject(
            false,
            true,
            CurrencyPairCalendarImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.holidays = <Array<CubiqTS.Holiday>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairCalendarImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.nonBaseccy = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: Array<CubiqTS.TenorToValueAndFixingDate> = this.baseEncoder.readObject(
            false,
            true,
            CurrencyPairCalendarImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.tenorToValueAndFixingDateSet = <Array<CubiqTS.TenorToValueAndFixingDate>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: Array<CubiqTS.TenorToValueDate> = this.baseEncoder.readObject(
            false,
            true,
            CurrencyPairCalendarImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.tenorToValueDateSet = <Array<CubiqTS.TenorToValueDate>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairCalendarImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.isNdfEnabled = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.StandardDate = this.baseEncoder.readObject(
            true,
            false,
            CurrencyPairCalendarImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.maxValueDate = <CubiqTS.StandardDate>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.StandardDate = this.baseEncoder.readObject(
            true,
            false,
            CurrencyPairCalendarImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.tradeDateRollDate = <CubiqTS.StandardDate>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: CubiqTS.StandardTime = this.baseEncoder.readObject(
            true,
            false,
            CurrencyPairCalendarImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.tradeDateRollTime = <CubiqTS.StandardTime>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairCalendarImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,CurrencyPairCalendarImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return CurrencyPairCalendarImplEncoder.fidTypeMap.has(fid);
  }
}
